import axios, { AxiosPromise } from 'axios';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import routes from 'routes';
import { HomeTransferStatusType } from './types';

export function getHomeTransferStatus(statusId: string): AxiosPromise<HomeTransferStatusType> {
  return axios.get(routes.homeTransferStatus(statusId));
}

export function useGetHomeTransferStatus(
  contractID: string | undefined,
): UseQueryResult<HomeTransferStatusType> {
  return useQuery({
    queryKey: ['homeTransferStatus', contractID],
    queryFn: async () => {
      if (!contractID) throw new Error('contractId is required');
      const response = await getHomeTransferStatus(contractID);
      return response.data;
    },
    enabled: Boolean(contractID),
  });
}
